// removed by extract-text-webpack-plugin
module.exports = {"button":"button___6y6Zv","whiteButton":"whiteButton___pHZu4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.css
// module id = 200
// module chunks = 0